import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "15",
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M10.7501 14.9199H11.4001C12.0501 14.9199 12.5901 14.3399 12.5901 13.6399C12.5901 12.7699 12.2801 12.5999 11.7701 12.4199L10.7601 12.0699V14.9199H10.7501Z",
  fill: "#697B8E"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M9.97007 0.899919C4.45007 0.919919 -0.0199331 5.40992 6.68532e-05 10.9299C0.0200669 16.4499 4.51007 20.9199 10.0301 20.8999C15.5501 20.8799 20.0201 16.3899 20.0001 10.8699C19.9801 5.34992 15.4901 0.889919 9.97007 0.899919ZM12.2601 10.9999C13.0401 11.2699 14.0901 11.8499 14.0901 13.6399C14.0901 15.1799 12.8801 16.4199 11.4001 16.4199H10.7501V16.9999C10.7501 17.4099 10.4101 17.7499 10.0001 17.7499C9.59007 17.7499 9.25007 17.4099 9.25007 16.9999V16.4199H8.89007C7.25007 16.4199 5.92007 15.0399 5.92007 13.3399C5.92007 12.9299 6.26007 12.5899 6.67007 12.5899C7.08007 12.5899 7.42007 12.9299 7.42007 13.3399C7.42007 14.2099 8.08007 14.9199 8.89007 14.9199H9.25007V11.5399L7.74007 10.9999C6.96007 10.7299 5.91007 10.1499 5.91007 8.35992C5.91007 6.81992 7.12007 5.57992 8.60007 5.57992H9.25007V4.99992C9.25007 4.58992 9.59007 4.24992 10.0001 4.24992C10.4101 4.24992 10.7501 4.58992 10.7501 4.99992V5.57992H11.1101C12.7501 5.57992 14.0801 6.95992 14.0801 8.65992C14.0801 9.06992 13.7401 9.40992 13.3301 9.40992C12.9201 9.40992 12.5801 9.06992 12.5801 8.65992C12.5801 7.78992 11.9201 7.07992 11.1101 7.07992H10.7501V10.4599L12.2601 10.9999Z",
  fill: "#697B8E"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M7.42007 8.36992C7.42007 9.23992 7.73007 9.40992 8.24007 9.58992L9.25007 9.93992V7.07992H8.60007C7.95007 7.07992 7.42007 7.65992 7.42007 8.36992Z",
  fill: "#697B8E"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

import { withDefaults } from 'vue';

interface IProps {
  color?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CostCenterIcon',
  props: {
    color: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
}

})